import React, { useState, useEffect } from "react";
import useWindowsSize from "@/hooks/useWindowsSize";
import helpers, { sendMessageToApp } from "@/utils/helpers";
import iconGruaRimac from "@/assets/rebrand/body/coverageSection/iconGruaRimac.svg";
import imgChatAgendado from "@/assets/rebrand/body/coverageSection/imgChatAgendadoSoat.png";
import imgSoatRimac from "@/assets/rebrand/body/coverageSection/imgSoatRimac.png";
import {
  RideGrid,
  RideIconButton,
  RideGlRight,
} from "@rimac-seguros/ride-system-components";
import useBreakpoint from "@/hooks/useBreakpoint";

import DynamicIcon from "@/components/atoms/DynamicIcon/index";

import "./styles.scss";
import Modal from "@/components/rebrand/modal/modal";
import { useSelector } from "react-redux";

const rangesQueries = [
  { min: 360, max: 795, offsetMin: 200, offsetMax: 1200 },
  { min: 796, max: 1359, offsetMin: 400, offsetMax: 1500 },
  { min: 1360, max: 9999, offsetMin: 500, offsetMax: 1700 },
];

const coverageImg = [
  {
    name: "Grua rimac",
    img: iconGruaRimac,
  },
  {
    name: "Chat agendado Soat Rimac",
    img: imgChatAgendado,
  },
  {
    name: "Soat Rimac",
    img: imgSoatRimac,
  },
];

const RbrCoverage = (props) => {
  const { altImg, coverageTitle, coverages } = props.authoring;

  const [offset, setOffset] = useState(0);
  const { width: windowWidth } = useWindowsSize();
  const [active, setActive] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [listModal, setListModal] = useState([]);

  const isDesktop = useBreakpoint("large-min");

  const { isEmbedded } = useSelector((state) => state.embeddedReducer);

  const valuesForComp = rangesQueries.find(
    (item) => windowWidth >= item.min && windowWidth <= item.max
  );

  useEffect(() => {
    window.onscroll = () => {
      setOffset(window.pageYOffset);
    };
  }, []);

  useEffect(() => {
    if (offset === valuesForComp?.offsetMin) {
      setActive(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset]);

  const activeImg = offset >= valuesForComp?.offsetMin || active;

  const handleOpenModal = (data) => () => {
    if (isEmbedded) sendMessageToApp("EMBEDDED-APP-HIDE-TOPBAR");
    setOpenModal(true);
    setModalData(coverages[data]);
    setListModal(coverages[data].listModal);

    helpers.getTagAction(
      "Consulta SOAT",
      "Descubre los beneficios RIMAC",
      "Click",
      `${coverages[data].title}`,
      "trackAction"
    );
  };

  const handleCloseModal = () => {
    if (isEmbedded) sendMessageToApp("EMBEDDED-APP-SHOW-TOPBAR");
    setOpenModal(false);
  };

  return (
    <div className="beneficit-box">
      <div id="section-coverage" className="container-rbrcoverage primary-bg">
        <RideGrid>
          <div className="container-rbrcoverage__left">
            <div className="container-rbrcoverage__img">
              <div className="imgPlusIcon">
                <img
                  src={coverageImg[0].img}
                  className={`icon-grua rbr-hide-tablet-on-up ${
                    activeImg ? "active" : ""
                  }`}
                  alt={altImg}
                  loading="lazy"
                />
                <img
                  src={coverageImg[2].img}
                  className="rbr-hide-tablet-on-up car-people"
                  alt={altImg}
                  loading="lazy"
                />
              </div>
              <img
                src={coverageImg[1].img}
                className={`img-chat rbr-hide-tablet-on-up ${
                  activeImg ? "active" : ""
                }`}
                alt={altImg}
                loading="lazy"
              />
            </div>
          </div>
          <div className="container-rbrcoverage__right">
            <h2 className="container-rbrcoverage__title">{coverageTitle}</h2>
            {coverages.map((item, index) => (
              <div className="container-rbrcoverage__row" key={index}>
                <DynamicIcon
                  icon={item.icon}
                  size={isDesktop ? "medium" : "small"}
                />
                <div className="container-rbrcoverage__col">
                  <div className="cov-title font-bold font-br">
                    {item.title}
                  </div>
                  <RideIconButton
                    glyph={<RideGlRight />}
                    size={isDesktop ? "large" : "small"}
                    variant="outline"
                    aria-label="Icon Button"
                    onClick={handleOpenModal(index)}
                  />
                </div>
              </div>
            ))}
          </div>
        </RideGrid>
      </div>
      <div className="modal-benefit">
        <Modal
          onClose={handleCloseModal}
          active={openModal}
          classModal="modal-shipping-policy"
          body={
            modalData.code === "principal" ? (
              <div className="modal-first">
                <div className="modal-benefit__title">{modalData.title}</div>
                {modalData.list.map(({ title, description, icon }) => (
                  <div className="modal-benefit__box">
                    <img src={icon} alt={title} />
                    <div>
                      <p className="modal-benefit__subtitle">{title}</p>
                      <p className="modal-benefit__description">
                        {description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="modal-second">
                <img
                  className="modal-second__desktop"
                  src={imgSoatRimac}
                  alt="img modal"
                />
                <img
                  className="modal-second__responsive"
                  src={imgSoatRimac}
                  alt="img modal"
                />
                <div className="modal-second__box">
                  <div className="modal-second__title">
                    {modalData.titleModal}
                  </div>
                  <div className="modal-second__description">
                    <p className="paragraph-subtitle">
                      {modalData.subtitleModal}
                    </p>
                    {modalData.paragraphModal && (
                      <p className="paragraph-content">
                        {modalData.paragraphModal}
                      </p>
                    )}
                    {modalData.subtitleTitleModal && (
                      <p className="paragraph-subtitle-title">
                        {modalData.subtitleTitleModal}
                      </p>
                    )}
                    {listModal.map(({ id, text }) => (
                      <li key={id}>{text}</li>
                    ))}
                  </div>
                </div>
              </div>
            )
          }
        />
      </div>
    </div>
  );
};

export default RbrCoverage;
